'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n'], ['\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  display: inline-block;\n  position: relative;\n  min-width: ', ';\n  height: ', ';\n  cursor: pointer;\n  margin-right: ', ';\n\n  input[type=\'radio\'] {\n    cursor: pointer;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n\n    & ~ ', ' {\n      border-radius: 50%;\n      border: ', ' solid ', ';\n      box-shadow: ', ';\n      transition: background 0.2s, border 0.2s;\n      svg {\n        border: ', ' solid transparent;\n        transform: scale(0);\n        transition: transform 0.2s ease-out;\n        background: ', ';\n        border-radius: 50%;\n        width: ', ';\n        height: ', ';\n      }\n    }\n\n    &:checked ~ ', ' {\n      svg {\n        transform: scale(1);\n        border: ', ' solid #fff;\n        background: ', ';\n      }\n    }\n\n    &:disabled:checked ~ ', ' {\n      cursor: not-allowed;\n      border: ', ' solid ', ';\n      svg {\n        background: ', ';\n      }\n    }\n\n    &:disabled ~ ', ' {\n      cursor: not-allowed;\n    }\n  }\n'], ['\n  display: inline-block;\n  position: relative;\n  min-width: ', ';\n  height: ', ';\n  cursor: pointer;\n  margin-right: ', ';\n\n  input[type=\'radio\'] {\n    cursor: pointer;\n    margin: 0;\n    padding: 0;\n    opacity: 0;\n\n    & ~ ', ' {\n      border-radius: 50%;\n      border: ', ' solid ', ';\n      box-shadow: ', ';\n      transition: background 0.2s, border 0.2s;\n      svg {\n        border: ', ' solid transparent;\n        transform: scale(0);\n        transition: transform 0.2s ease-out;\n        background: ', ';\n        border-radius: 50%;\n        width: ', ';\n        height: ', ';\n      }\n    }\n\n    &:checked ~ ', ' {\n      svg {\n        transform: scale(1);\n        border: ', ' solid #fff;\n        background: ', ';\n      }\n    }\n\n    &:disabled:checked ~ ', ' {\n      cursor: not-allowed;\n      border: ', ' solid ', ';\n      svg {\n        background: ', ';\n      }\n    }\n\n    &:disabled ~ ', ' {\n      cursor: not-allowed;\n    }\n  }\n']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var IconWrapper = _styledComponents2.default.span(_templateObject);

var Wrapper = _styledComponents2.default.label(_templateObject2, (0, _polished.rem)(18), (0, _polished.rem)(18), (0, _polished.rem)(10), IconWrapper, (0, _polished.rem)(1), function (_ref) {
  var theme = _ref.theme;
  return theme.form.placeholderColor;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.smallShadow;
}, (0, _polished.rem)(4), function (_ref3) {
  var theme = _ref3.theme;
  return theme.color.placeholderColor;
}, (0, _polished.rem)(10), (0, _polished.rem)(10), IconWrapper, (0, _polished.rem)(1), function (_ref4) {
  var theme = _ref4.theme;
  return theme.color.primary;
}, IconWrapper, (0, _polished.rem)(1), function (_ref5) {
  var theme = _ref5.theme;
  return theme.form.placeholderColor;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.form.placeholderColor;
}, IconWrapper);

var Radio = function Radio(props, context) {
  var id = props.id,
      name = props.name,
      rest = _objectWithoutProperties(props, ['id', 'name']);

  return _react2.default.createElement(
    Wrapper,
    null,
    _react2.default.createElement('input', _extends({}, rest, {
      name: name,
      type: 'radio',
      role: 'radio',
      id: id || context.id
    })),
    _react2.default.createElement(
      IconWrapper,
      null,
      _react2.default.createElement('svg', { width: '12', height: '12' })
    )
  );
};

Radio.defaultProps = {
  name: null
};

Radio.contextTypes = {
  name: _propTypes2.default.string
};

exports.default = Radio;
Radio.__docgenInfo = [{
  'description': '',
  'displayName': 'Radio',
  'methods': [],
  'props': {
    'name': {
      'defaultValue': {
        'value': 'null',
        'computed': false
      },
      'required': false
    }
  },
  'context': {
    'name': {
      'type': {
        'name': 'string'
      },
      'required': false
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/Radio/index.js'] = {
    name: 'Radio',
    docgenInfo: Radio.__docgenInfo,
    path: 'src/Radio/index.js'
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/oxyrion-ui/lib/Radio/index.js
// module id = 179
// module chunks = 1